module.exports = __webpack_public_path__ + "static/media/ico_tint_alt_01.260015af.svg";